import BMap from 'BMap'
// import BMAP_ANCHOR_TOP_RIGHT from 'BMAP_ANCHOR_TOP_RIGHT'
// import BMAP_ANCHOR_TOP_LEFT from 'BMAP_ANCHOR_TOP_LEFT'
import bus from '../../bus/bus'
import i18n from '../../i18n/i18n'
class MarkerLabelControl extends BMap.Control {
  constructor (option) {
    super()
    // 默认停靠位置和偏移量
    // 也可以由传入的参数控制
    this.defaultAnchor = option.anchor || BMAP_ANCHOR_TOP_LEFT
    this.defaultOffset = option.offset || new BMap.Size(20, 20)
    // 自定义参数
    // .....
    this.text = i18n.t('home.showNames')
    this.zoom = ''
    this.isShowingName = false
  }
  computedText () {
    return this.isShowingName ? i18n.t('home.hideNames') : i18n.t('home.showNames')
  }
  computedEvent () {
    return this.isShowingName ? 'hideMarkerName' : 'showMarkerName'
  }
  setText(){
      this.node.innerHTML = this.computedText()
  }
  initialize (map) {
    const div = document.createElement('div')
    this.node = div
    // 添加文字说明
    this.zoom = map.getZoom()
    
    div.appendChild(document.createTextNode(this.computedText()))
    // 设置样式
    div.style.border = ".5px solid #aaa"
    div.style.fontSize = '12px'
    div.style.backgroundColor = 'rgba(139, 164, 220, .9)'
    div.style.color = 'rgb(255, 255, 255)'
    div.style.padding = '3px 6px'
    div.style.boxShadow = '2px 2px 3px rgba(0, 0, 0, 0.35)'
    // div.s
    const clickFunction = () => {
      bus.$emit(this.computedEvent())
      // console.log(div.childNodes)
      this.isShowingName = !this.isShowingName
      div.innerText = this.computedText()
    }
    if (this.zoom >= 15) {
      div.style.cursor = "pointer"
      // 监听点击事件
      div.addEventListener('click', clickFunction)
    }
    // 地图添加监听缩放事件
    map.addEventListener('zoomend', () => {
      div.removeEventListener('click', clickFunction)
      this.zoom = map.getZoom()
      // console.log(this.zoom)
      if (this.zoom >= 15) {
        div.style.cursor = "pointer"
        // 监听点击事件
        div.addEventListener('click', clickFunction)
      } else {
        div.removeEventListener('click', clickFunction)
        // console.log('取消监听点击事件')
        div.style.cursor = 'not-allowed'
        if (this.isShowingName) {
          bus.$emit('hideMarkerName')
          // console.log(div)
          this.isShowingName = false
          div.innerText = '显示人员姓名'
        }
      }
    })
    // 添加DOM元素到地图中
    map.getContainer().appendChild(div)
    // 将DOM元素返回
    return div
  }
}

export default MarkerLabelControl